import type { ReactNode } from 'react';
import type { SxProps, Theme } from '@mui/material';

import { Box, Typography, useTheme } from '@mui/material';
import { mergeSx } from '@/shared/utils/merge-sx.util';
import { MuiSxCollection } from '@/shared/types/utility.type';

interface InfoBannerProps {
  icon: ReactNode;
  children: ReactNode;
  dataTestId?: string;
  sx?: SxProps<Theme>;
}

export const InfoBanner = ({ icon, children, dataTestId, sx = {} }: InfoBannerProps) => {
  const theme = useTheme();
  const styles = getStyles(theme);
  return (
    <Box data-testid={dataTestId} sx={mergeSx(styles.container, sx)}>
      <Box sx={styles.icon}>{icon}</Box>
      <Typography variant="body2" sx={styles.text}>
        {children}
      </Typography>
    </Box>
  );
};

const getStyles = (theme: Theme): MuiSxCollection => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    px: '16px',
    py: '6px',
    borderRadius: '8px',
    backgroundColor: theme.palette.coolGrey[100],
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.neutralGrey[950],
    width: '22px',
    height: '22px',
    fontSize: '22px',
    p: '7px 12px 7px 0',
  },
  text: {
    color: theme.palette.neutralGrey[950],
    textAlign: 'center',
    alignSelf: 'stretch',
    py: '8px',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
  },
});
